<template>
  <v-card
    class="mx-auto mt-2 hidden-lg-and-up"
    max-width="100%"
    outlined
  >
    <v-list-item three-line>
      <v-list-item-avatar
        tile
        size="88"
      >
        <v-img src="https://via.placeholder.com/88"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <div class="overline mb-4" id="iteration-style">Iteration 1 Id: 2</div>
        <v-list-item-title class="headline mb-1 title" id="title-style">{{ template.TemplateName }}</v-list-item-title>
        <v-list-item-subtitle>
          <!-- <v-chip v-for="(tag, index) in template.tags" :key="tag" :class="{ 'ml-2': index > 0 }">{{ tag }}</v-chip> -->
          <v-chip>{{ template.ApplicationName }}</v-chip>
          <v-chip class="ml-2">{{ template.ApplicationProviderName }}</v-chip>

        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions class="actions">
      <v-container fluid>
        <v-layout wrap align-center class="card-actions">
          <v-flex xs10 class="text-left">
            <v-btn class="action-button" text>Release Notes <v-icon right id="icon-style">fas fa-external-link-alt</v-icon></v-btn>
            <v-btn class="action-button" text>{{ template.CreatorSub }} <v-icon right id="icon-style">fas fa-envelope</v-icon></v-btn>
          </v-flex>
          <v-flex xs2 class="text-right">
            <v-btn id="run-btn-style" :to="`/environments/${template.Id}/run`"><v-icon left>fas fa-upload</v-icon>Run</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['template']
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');

div {
  font-family: 'Montserrat';
}

.actions {
  background: #F9F9F9;
}

.card-actions, .action-button {
  font-size: .8em;
}

#run-btn-style {
  background-color: #5EBE50;
  color: #fff;
  font-size: .9em;
  border-radius: 13px;
}

#icon-style {
  color: #D0398B;
}

#title-style {
  font: bold 16px/19px 'Montserrat' !important;
  text-align: left;
}

#iteration-style {
  opacity: 1;
  color:#888888;
  text-align: left;
  font: 12px/15px 'Montserrat' !important;
  letter-spacing: 0 !important;
}
</style>
